<template>
  <div class="add-jobs-work-one-report">
    <div class="close-header">
      <i class="el-icon-close" @click="closeModal"></i>
    </div>
    <div class="add-jobs-work">
      <div class="search-jobs-work" style="margin-top: -16px; margin-bottom: 4px; width: 100%">
        <div :class="['arrow-main' , {hide: hideAll}]" @click="hideAllHandler">
          <i :class="'fas fa-chevron-right'"></i>
        </div>
        <el-input placeholder="Поиск ..." v-model="search" class="input-search">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </div>
    </div>

    <div v-for="(object, index) in format(objects)" :key="object.id + index"
         v-show="(object.name || '').toLowerCase().includes(search.toLowerCase())">
      <div class="main-object-block">
        <div class="object-container" v-if="object.name">
          <div class="object-name">
            <div style="display:flex; align-items: center">
              <div @click="hideLines(index)" class="arrow-main"
                   :class="['arrow-main' , {hide: hides[index]}]">
                <i class="fa fa-chevron-right"></i>
              </div>
              <div class="name" v-if="object.name" @click="!approve ? removeObj(object, index) : () => {}">
                <span
                  class="name-click"
                  v-for="(obj, index) in (object.name || '').split(' > ')"> {{ index > 0 ? ' > ' : '' }} {{
                    obj
                  }}
                </span>

                <i class="el-icon-close" v-if="!approve"></i>
              </div>
              <div class="name" v-else>
                <span>Без объекта</span>
              </div>
            </div>
          </div>
        </div>

        <div         v-if="!lock" class="job-container" v-for="(job, i) in object.jobs" v-show="!hides[index]"
             :key="i + '_' + index  + '_' + job.id">
          <add-jobs-prof
            :report="report"
            :type="type" :approve="approve" :isEditable="isEditable"
            v-model="objects[index].jobs[i]"
            :user="user"
            :main-form="mainForm"
            @remove="() => {
               objects[index].jobs.splice(i, 1)
                objects[index].jobs = [...objects[index].jobs]
            }"
            :workTypeOptions="work_type_options"
            :currentIndex="index"
            :options_works="options_works"
            ref="addJobs"/>
        </div>
        <div v-show="!hides[index]" class="add-main-job" style="padding-right: 38px; box-sizing: border-box">
              <div class="plus-btn" v-if="isEditable && !approve" @click="() => {objects[index].jobs.push({
                  jobs: [],
                  work_type: null,
                  work_type_dir: null
              })}">
            +
          </div>
        </div>
      </div>
    </div>

    <create-jobs-work   :report="report"  :approve="approve" v-if="objects.length" :isEditable="isEditable" @remove="removeJob"
                      ref="createJobsWork"
                      @save="createJobs" @copy="copyJob"/>

    <AddObjectsWork :report="report" :approve="approve" :isEditable="isEditable" ref="addObject" @add-objects="addObjects"
                :index="objects.length"/>


    <!--    <div class="btn-footer">-->
    <!--      <div class="plus-btn">+</div>-->
    <!--    </div>-->

    <div class="footer-jobs">
      <el-button  type="danger" @click="deleteAll" v-if="!approve">Удалить</el-button>
      <el-button  type="primary" @click="hideAllHandler" v-if="!approve">Сохранить</el-button>
      <el-button @click="closeModal">Закрыть</el-button>

    </div>
  </div>
</template>

<script>
import AddObjectJobsWork from "./AddObjectJobsWork";
import CreateJobsWork from "./CreateJobsWork";
import CreateJobsReport from "./CreateJobsReport";
import AddJobsProf from "./AddJobsProf";
import firebase from "firebase";
import {calculatePercentage, pStatus} from "../../../../utils/numberUtils";
import AddObjects from "./AddObjects";
import AddObjectsWork from "./AddObjectsWork";

export default {
  name: "AddJobsWorkProf",
  components: {AddObjectsWork, AddObjects, AddJobsProf, CreateJobsReport, CreateJobsWork, AddObjectJobsWork},
  props: ['index', 'report', 'inputObjects', 'mainForm', 'options_works', 'user', 'approve', 'isEditable', 'type', 'dirs'],
  data() {
    return {
      search: '',
      savedForm: null,
      lock: true,
      objects: [{
        id: null,
        index: 0,
        name:"",
        parentId: null,
        jobs: [{
          jobs: [],
          work_type: null,
          work_type_dir: null
        }],
      }],
      hides: {},
      hideAll: false,
      work_type_options: [],
      removeIds: [],
    }
  },
  async mounted() {


    this.objects = this.inputObjects || [{
      id: null,
      index: 0,
      name:"",
      parentId: null,
      jobs: [{
        jobs: [],
        work_type: null,
        work_type_dir: null
      }],
    }]


    this.savedForm = JSON.parse(JSON.stringify(this.objects))

    this.lock = false

    this.getWorkType('job')
  },
  computed: {
    isShowPlus() {
      return !this.objects.find(({name, index}) => !name && !index)
    }
  },
  watch: {
    objects: {
      handler: (function (e, prev) {
        if( JSON.parse(JSON.stringify(prev)) !== JSON.parse(JSON.stringify(e))) {
          this.$emit('update', e)
        }
      }, 500),
      deep: true
    }
  },
  methods: {
    closeModal() {
      this.objects = this.savedForm;
      setTimeout(() => {
        this.$emit('close')
      }, 500)
    },
    deleteAll() {
      this.$confirm('После подтверждения, данные будут удалены!', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        this.objects = [{
          id: null,
          index: 0,
          name: "",
          parentId: null,
          jobs: [{
            jobs: [],
            work_type: null,
            work_type_dir: null
          }],
        }]

        this.$emit('close')
      })
    },
    hideAllHandler() {
      console.log(this.objects, 'this.objects')
      this.$emit('update', this.objects)
      this.$emit('close')
    },
    pStatus,
    calculatePercentage,
    getRemoveIds() {
      return this.removeIds;
    },
    getTotalValueAndPlan(job) {
      let valueR = 0, planR = 0

      try {

        if (job) {
          job.reports.forEach(({jobs}) => {
            try {
              if (jobs) {
                jobs.forEach((job) => {
                  valueR += Number(job.value)
                  planR += Number(job.job.plan)
                })
              }
            } catch (e) {
            }
          })
        }
      } catch (e) {
      }

      return {value: valueR, plan: planR}
    },
    removeJob(job) {
      this.removeIds.push(job.removeId)

      const index = this.objects.findIndex(({id}) => job.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.splice(job.editId, 1)
        this.objects = [...this.objects]
      }
    },
    hideLines(index) {
      if (!this.hides[index]) {
        this.hides[index] = true
        return this.hides = {...this.hides}
      }
      this.hides[index] = !this.hides[index]
      this.hides = {...this.hides}

    },
    calcObjectPlan(object) {
      let result = {
        plan: 0,
        value: 0
      }

      object.jobs.forEach((p) => {
        result.plan += Number(p.plan || 0)
        result.value += this.calcValue(p)
      });

      return calculatePercentage(result.value || 0, result.plan || 0) || 0
    },
    getWorkType(type) {
      console.log('GET_WORK_TYEP c')

      return new Promise((resolve) => {
        const result = [];
        firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('works_type')
          .where('type', '==', type).get().then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();
            result.push({
              data: data,
              value: subDoc.id,
              label: (data.name || data.id || '') + (data.stamp ? ' ' + data.stamp : ''),
            });
          });
          this.work_type_options = result;
          resolve()
        });
      });
    },
    openJobDialog(obj = {}, job = null, index, jobIndex = null) {
      this.$refs.addJobs.open(job, jobIndex, index, obj)
    },
    format(objects) {
      return JSON.parse(JSON.stringify(objects))
    },
    openJob(obj = {}, job = null, index = null) {
      const id = obj ? obj.id : null;
      this.$refs.createJobsWork.openHandler(id, job, index)
    },
    calcValue(job) {
      return job.value || job.fact || 0
    },
    copyJob(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (index !== -1) {
        this.objects[index].jobs.push({...form.form, reports: []})

      }
    },
    createJobs(form) {
      const index = this.objects.findIndex(({id}) => form.structureObj === id)

      if (form.editId === null && index !== -1) {
        this.objects[index].jobs.push(form.form)

        return this.objects = [...this.objects]
      }

      if (index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [form.form]
        })
        return this.objects = [...this.objects]
      }


      if (index !== -1) {
        this.objects[index].jobs[form.editId] = {
          ...this.objects[index].jobs[form.editId],
          ...form.form
        }
      } else {
        this.objects[this.objects.length - 1] = {
          ...this.objects[this.objects.length - 1],
          jobs: [...this.objects[this.objects.length - 1].jobs, form.form]
        }
      }

      this.objects = [...this.objects]
    },
    removeReport(form) {
      delete this.objects[form.structureObj].jobs[form.editIndex];
      this.objects = [...this.objects]
    },
    addJobs(form) {
      const index = form.structureObj

      if (index !== -1 && !form.editId) {
        if (!this.objects[index].jobs) {
          this.objects[index].jobs = []
        }

        if (form.editIndex !== null && form.editIndex !== undefined) {
          this.objects[index].jobs[form.editIndex] = form.form

        } else {
          this.objects[index].jobs.push(form.form)

        }
        this.objects = [...this.objects]
        return;
      }

      if (form.structureObj === null && index === -1) {
        this.objects.push({
          id: null,
          index: null,
          name: null,
          parentId: null,
          jobs: [],
        })

      } else if (index === -1) {
        return
      }

      if (index !== -1) {
        this.objects[index] = {
          ...this.objects[index],
          jobs: [...this.objects[index].jobs]
        }
      }


      this.objects = [...this.objects]
    },
    removeObj(obj, index) {
      this.$confirm('После удаления объекта, все работы по нему будут удалены!', 'Подтверждение', {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Нет',
        type: 'warning',
      }).then(() => {
        delete this.objects[index]
        this.objects = [...this.objects].filter((ob) => ob)
      });
    },
    openObj() {
      this.$refs.addObject.open(null)
    },
    insertObject(arr, newObj) {
      let maxMatch = 0;
      let insertIndex = arr.length;
      let newStr = newObj.name;

      for (let i = 0; i < arr.length; i++) {
        let currentStr = arr[i].name + ' >';
        let matchLength = 0;

        while (matchLength < currentStr.length && matchLength < newStr.length && currentStr[matchLength] === newStr[matchLength]) {
          matchLength++;
        }

        if (matchLength > maxMatch) {
          maxMatch = matchLength;
          insertIndex = i + 1;
        }
      }

      arr.splice(insertIndex, 0, newObj);
      return arr;
    },
    addObjects(objs) {


      if (!objs) {
        return
      }


      this.objects.push({...objs, jobs: []})

      // const objects = this.objects.filter(({id}) => id)
      // console.log(objects, objs[0], 'objs')
      //
      //
      // if(objs.mainId || !objs.name.includes(' > ')) {
      //   this.objects = _.uniqBy([...this.objects, {...objs}], 'id')
      // } else {
      //   this.objects = _.uniqBy(this.insertObject(objects, objs), 'id')
      // }
    },
    openObjectEdit(object, name) {
      this.$refs.addObject.open(object, name)
    }
  }
}
</script>

<style scoped lang="scss">
.add-jobs-work {
  margin-top: 6px;
}

.search-jobs-work {
  display: flex;
  align-items: center;
}

.arrow-main {
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  width: 32px;
  height: 22px;
  justify-content: center;
  transform: rotate(90deg);


  &.hide {
    transform: rotate(-90deg) !important;
  }
}

.add-main-job {
  margin-top: 8px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: flex-end;

  span {
    font-size: 13px;
    font-weight: bold;
    margin-right: 4px;
    margin-left: 4px;
    color: #13ce66;
  }

  i {
    cursor: pointer;
    font-size: 30px;
  }
}

.precent {
  font-size: 13px;
  font-weight: bold;
  margin-right: 4px;
  margin-left: 4px;
  color: #13ce66;
}

.object-name {
  display: flex;
}

.object-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.object-name {
  display: flex;
  align-items: center;
  color: #000000;
  font-size: 14px;
  font-weight: bold;
}

.name {
  text-align: left;
}

.main-object-block {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.object-container {
  margin-bottom: 8px;
}

.arrow-main {
  width: 42px;
  font-size: 18px;
}

.job-inputs {
  display: flex;
  align-items: center;
  margin-right: 4px;

  i {
    padding-left: 4px;
    cursor: pointer;
  }
}

.input {
  margin-right: 8px;
}

.job-container {
  margin-top: 12px;
  display: flex;
  margin-bottom: 4px;
  flex-direction: column;
  align-items: flex-start;
}

.name-click {
  cursor: pointer;
}

.plus-btn {
  width: 48px;
  height: 32px;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff8c00;
}

.fa-chevron-right {
  font-size: 20px;
}

.work_custom {
  color: #4a36cb;
  font-weight: 500;
}

.plus-btn {
  width: 48px;
  height: 32px;
  font-size: 22px;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff8c00;
}


.btn-footer {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 12px;
  padding-right: 12px;
}

.footer-jobs {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 42px;
}

.close-header {
  position: absolute;
  width: 100%;
  margin-top: -54px;
  font-size: 18px;
  i {
    cursor: pointer;
  }
  display: flex;
  justify-content: flex-end;
  padding-right: 42px;
  box-sizing: border-box;
}
</style>
<style lang="scss">
.comment-rep textarea {
  height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOneComplete/components/AddJobsWorkProf.vue